import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Links } from "../util/util";

class Footer extends Component {
    render = () => (
        <footer className="footer-area ignore-padding">
            <div className="container">
                <div className="d-flex justify-content-between flex-d-row-md flex-d-column-xs">
                    <div className="columns-3-lg columns-6-md columns-12-sm">
                        <div className="single-footer footer-navbar-nav">
                            <img src={require("../assets/img/firebits-icon.svg").default}
                                 style={{ height: '112px' }}
                                 alt="Firebits icon" />
                            <p className="body2" style={{ marginTop: 36, maxWidth: 250 }}>
                                Ready to take your project to the next level?
                            </p>
                            <p className="body4 medium monospaced" style={{ marginTop: 8 }}>
                                <a href={Links.EMAIL_LINK}>{Links.EMAIL}</a>
                            </p>
                        </div>
                    </div>

                    <div className="d-flex link-sections flex-d-row-md flex-d-column-xs">
                        <div className="columns-3-lg columns-6-md">
                            <div className="single-footer link-section">
                                <h4 style={{ color: 'white' }}>
                                    {this.props.contactInfoTitle}
                                </h4>
                                <ul>
                                    <li>
                                        {this.props.location.pathname === Links.HOME ? (
                                            <a href='#about'>Why choose us?</a>
                                        ) : (
                                            <a href='/#about'>
                                                Why choose us?
                                            </a>
                                        )}
                                    </li>
                                    <li>
                                        <NavLink to={Links.WORK} activeClassName="">
                                            Our recent work
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to={Links.ABOUT} activeClassName="">
                                            Services
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="columns-3-lg columns-6-md">
                                    <div className="single-footer link-section">
                                        <h4 style={{color: 'white'}}>
                                            Follow us
                                        </h4>
                                        <ul>
                                            <li>
                                                <NavLink to={this.props.fbLink}>
                                                    <div className="text-icon">
                                                        <img src={require("../assets/img/facebook-icon.svg")}
                                                             alt="facebook icon"/>
                                                        <span>Facebook</span>
                                                    </div>
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                    </div>
                </div>
            </div>
            <div className="copyright-area" style={{ marginTop: 50 }}>
                <div className="container">
                    <p>{this.props.copyRightText}</p>
                </div>
            </div>
        </footer>
    );
}

//Props Types
Footer.propTypes = {
    siteDescription: PropTypes.string,
    btnText: PropTypes.string,
    btnLink: PropTypes.string,

    usefullLinksTitle: PropTypes.string,

    supportTitle: PropTypes.string,
    supportsLinks: PropTypes.array,

    contactInfoTitle: PropTypes.string,
    contactInfoText: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,

    fbLink: PropTypes.string,
    twitterlLink: PropTypes.string,
    instagramlLink: PropTypes.string,
    linkedinlLink: PropTypes.string,
    vimeolLink: PropTypes.string
};

//Default Props
Footer.defaultProps = {
    siteDescription:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut. sed do eiusmod tempor incididunt ut, tempor incididunt ut.",
    btnText: "Read More",
    btnLink: "#",

    usefullLinksTitle: "FireBits",

    supportTitle: "Support",
    supportsLinks: [
        {
            Name: "Career",
            Link: "#"
        },
        {
            Name: "Support",
            Link: "#"
        },
        {
            Name: "Resource",
            Link: "#"
        },
        {
            Name: "Strategy",
            Link: "#"
        },
        {
            Name: "FAQ",
            Link: "#"
        },
        {
            Name: "Contact",
            Link: "#"
        }
    ],

    contactInfoTitle: "About",
    contactInfoText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    address: "2750 Quadra Street , Park Area, Victoria, Canada.",
    phone: "+(00) 01245687",
    email: "support@axolot.com",

    copyRightText: `Firebits © ${new Date().getFullYear()} All Rights Reserved`,
    fbLink: "#",
    twitterlLink: "#",
    instagramlLink: "#",
    linkedinlLink: "#",
    vimeolLink: "#"
};
export default withRouter(Footer);
